export default __webpack_public_path__ + "static/Economic Model Update - German-1dc89145e39cdc8a0f4c41d22af556bf.pdf";